import React from 'react';
import { AffiliationHeaderMolecule } from '../../Molecules';
import { FooterOrganism, AffiliationDispenseOrganism } from '../../Organisms';

function TemplateAffliation(props) {
    return (
        <div className="affiliation-container template-scroll">
            <AffiliationHeaderMolecule />
            {
                props.dispense
                    ? <AffiliationDispenseOrganism
                        dispenseCancelClicked={props.dispenseCancelClicked}
                        dispenseConfirmClicked={props.dispenseConfirmClicked}
                        DispenseOnecheck={props.DispenseOnecheck}
                        dispenseOneCheckClicked={props.dispenseOneCheckClicked}
                    />
                    : props.renderSwitch
            }
            <div className="affiliation-footer">
                <FooterOrganism />
            </div>
        </div>
    );
}

export default TemplateAffliation;
